import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=1a5edaf7&scoped=true&"
import script from "./Author.vue?vue&type=script&lang=js&"
export * from "./Author.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5edaf7",
  null
  
)

export default component.exports